import { useEffect, useState } from 'react';
import { Theme } from '../styles/Theme';

//export type Theme = 'dark' | 'light';

export const useThemeMode = (themes: { light: Theme; dark: Theme }): { theme: Theme; themeToggler: () => void } => {
  const [theme, setTheme] = useState<Theme>(themes.dark);

  const setMode = (mode: Theme) => {
    const modeString = 'light';//mode === themes.light ? 'light' : 'dark';
    window.localStorage.setItem('theme', modeString);
    setTheme(mode);
  };

  const themeToggler = () => {
    theme === themes.dark ? setMode(themes.light) : setMode(themes.dark);
  };

  useEffect(() => {
    const localTheme = window.localStorage.getItem('theme');
    if (localTheme) {
      setTheme(themes.light); //(localTheme === 'light' ? themes.light : themes.dark);
    }
    else {
      setTheme(themes.light);
    }
  }, []);

  return { theme, themeToggler };
};

export default useThemeMode;